/** @format */

import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";

const TYPE_ORDER = { deity: 0, occasion: 1, festivities: 2 };
const PAGE_SIZE = 10;

export default function PujaTag() {
  const [tag, setTag] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const getTags = useCallback(async () => {
    setLoading(true);
    ApiService.get('category').then((response) => {
      setLoading(false);
      if (response) {
        setTag(response.data);
      } else {
        setTag([]);
      }
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    getTags();
  }, [getTags]);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return [...tag]
      .filter(dp => dp.name?.toLowerCase().includes(q))
      .sort((a, b) => (TYPE_ORDER[a.type] ?? 99) - (TYPE_ORDER[b.type] ?? 99));
  }, [tag, search]);

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        {loading && <Loader />}
        <div className="card dz-card" id="bootstrap-table2">
          <div className="card-header flex-wrap d-flex justify-content-between border-0">
            <div>
              <h4 className="card-title">Puja Category List</h4>
            </div>
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search categories..."
                value={search}
                onChange={handleSearch}
                style={{ width: 220 }}
              />
              <Link to="/add-tag" className="btn btn-primary">
                Add Category
              </Link>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-responsive-md">
                <thead>
                  <tr>
                    <th><strong>Sr No.</strong></th>
                    <th><strong>Name</strong></th>
                    <th><strong>Type</strong></th>
                    <th><strong>Status</strong></th>
                    <th><strong>Action</strong></th>
                  </tr>
                </thead>
                <tbody>
                  {paginated.map((dp, key) => (
                    <tr key={dp.id}>
                      <td><strong>{(page - 1) * PAGE_SIZE + key + 1}</strong></td>
                      <td><span className="w-space-no">{dp.name}</span></td>
                      <td><span className="w-space-no">{dp.type}</span></td>
                      <td><span className="w-space-no">{dp?.isActive === true ? 'Active' : 'Inactive'}</span></td>
                      <td>
                        <Link
                          to={`/edit-tag/${dp?.id}`}
                          className="btn btn-primary shadow btn-xs sharp me-1"
                        >
                          <i className="fa fa-pencil" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                  {paginated.length === 0 && !loading && (
                    <tr><td colSpan={5} className="text-center text-muted">No categories found</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="text-muted" style={{ fontSize: 13 }}>
                  Showing {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, filtered.length)} of {filtered.length}
                </span>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                    <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setPage(p)}>{p}</button>
                    </li>
                  ))}
                  <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
